angular
  .module('surfsightApp.controllers')
  .controller('EdgeBroadcastViewController', [
    '$scope',
    '$rootScope',
    '$http',
    '$localStorage',
    '$mdDialog',
    '$mdToast',
    'edgeFactory',
    'broadcastsData',
    'broadcastViewId',
    'broadcastViewFactory',
    function (
      $scope,
      $rootScope,
      $http,
      $localStorage,
      $mdDialog,
      $mdToast,
      edgeFactory,
      broadcastsData,
      broadcastViewId,
      broadcastViewFactory
    ) {
      $scope.name = ''
      if (broadcastViewId) {
        const broadcastView = broadcastViewFactory.findItemById(broadcastViewId)
          .item
        $scope.name = broadcastView.name
      }

      $scope.saveBroadcastViewName = function () {
        const name = $scope.name
        const broadcastViewData = broadcastsData.dashcamStreams.map(
          dashcamStream => ({
            edgeId: dashcamStream.edgeId,
            serialNumber: dashcamStream.serialNumber,
            streamId: dashcamStream.streamId
          })
        )
        const userBroadcastView = {
          name,
          broadcastViewData
        }
        if (!broadcastViewId) {
          const requestJson = {
            method: 'POST',
            url: `${BROADCAST_BASEURL}/organizationUserBroadcastViews/${$rootScope.currentUserOrganization.id}`,
            data: userBroadcastView
          }
          $http(requestJson).then(
            function (response) {
              if (response.data.status.code === 0) {
                $mdDialog.hide(response)
              } else {
                $scope.showMessageToast(response.data.status.error)
              }
            },
            function (response) {
              handleServerError(response)
              $scope.showMessageToast(response.data.status.error)
            }
          )
        } else {
          const requestJson = {
            method: 'PUT',
            url: `${BROADCAST_BASEURL}/broadcastView/${broadcastViewId}`,
            data: userBroadcastView
          }
          $http(requestJson).then(
            function (response) {
              if (response.data.status.code == 0) {
                $mdDialog.hide(response)
              } else {
                $scope.showMessageToast(response.data.status.error)
              }
            },
            function (response) {
              handleServerError(response)
              $scope.showMessageToast(response.data.status.error)
            }
          )
        }
      }
      $scope.showMessageToast = function (message) {
        const toast = $mdToast
          .simple()
          .textContent(message)
          .action('ok')
          .actionKey('F1')
          .position('bottom middle')
          .hideDelay(3000)
          .parent('#broadcastview-add-container')

        $mdToast
          .show(toast)
          .then(function (response) {
            if (response === 'ok') {
              // alert('You clicked the \'UNDO\' action.');
            }
          })
          .catch(() => {})
      }
      $scope.cancel = function () {
        $mdDialog.cancel()
      }
      function handleServerError (response) {
        $scope.$emit('handleServerError', response)
      }
    }
  ])
